"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PasswordHiddenIcon = exports.PasswordVisibleIcon = exports.PasswordButtonDescription = exports.TogglePasswordButton = exports.TextInput = exports.PasswordInput = void 0;

var _tslib = require("tslib");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactFeather = require("react-feather");

var _Hidden = require("../../../../Modules/Hidden");

var _Box = _interopRequireDefault(require("../../../../Layout/Box"));

var _Text = _interopRequireDefault(require("../Text"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var PasswordInput = (0, _styledComponents.default)(_Box.default)(templateObject_1 || (templateObject_1 = (0, _tslib.__makeTemplateObject)(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
exports.PasswordInput = PasswordInput;
PasswordInput.displayName = 'PasswordInput';
var TextInput = (0, _styledComponents.default)(_Text.default)(templateObject_2 || (templateObject_2 = (0, _tslib.__makeTemplateObject)(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
exports.TextInput = TextInput;
TextInput.displayName = 'TextInput';

var TogglePasswordButton = _styledComponents.default.button(templateObject_3 || (templateObject_3 = (0, _tslib.__makeTemplateObject)(["\n  position: absolute;\n  cursor: pointer;\n  top: 50%;\n  transform: translate(0, -50%);\n  right: 12px;\n  background: transparent;\n  border: none;\n  color: rgb(146, 146, 146);\n\n  &:focus {\n    outline: 2px solid ", ";\n  }\n"], ["\n  position: absolute;\n  cursor: pointer;\n  top: 50%;\n  transform: translate(0, -50%);\n  right: 12px;\n  background: transparent;\n  border: none;\n  color: rgb(146, 146, 146);\n\n  &:focus {\n    outline: 2px solid ", ";\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.black;
});

exports.TogglePasswordButton = TogglePasswordButton;
TogglePasswordButton.displayName = 'TogglePasswordButton';

var PasswordButtonDescription = _styledComponents.default.span(templateObject_4 || (templateObject_4 = (0, _tslib.__makeTemplateObject)(["\n  ", "\n"], ["\n  ", "\n"])), _Hidden.hiddenCss);

exports.PasswordButtonDescription = PasswordButtonDescription;
PasswordButtonDescription.displayName = 'PasswordButtonDescription';
var PasswordVisibleIcon = (0, _styledComponents.default)(_reactFeather.Eye)(templateObject_5 || (templateObject_5 = (0, _tslib.__makeTemplateObject)(["\n  display: block;\n"], ["\n  display: block;\n"])));
exports.PasswordVisibleIcon = PasswordVisibleIcon;
PasswordVisibleIcon.displayName = 'PasswordVisibleIcon';
var PasswordHiddenIcon = (0, _styledComponents.default)(_reactFeather.EyeOff)(templateObject_6 || (templateObject_6 = (0, _tslib.__makeTemplateObject)(["\n  display: block;\n"], ["\n  display: block;\n"])));
exports.PasswordHiddenIcon = PasswordHiddenIcon;
PasswordHiddenIcon.displayName = 'PasswordHiddenIcon';
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;